import { isMobile } from '@/lib/device'
export default [
  {
    path: '/project/:pid',
    name: 'XiaomanLayout',
    props: true,
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/config/xiaoman/index.vue`),
    children: [{
      path: 'xiaoman/baseconfig',
      name: 'XiaomanBaseConfig',
      component: () => isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/xiaoman/baseConfig/BaseConfigMain'),
      meta: {
        title: '小满集成',
        menuKey: 'project-config'
      }
    },
    {
      path: 'xiaoman/setfields',
      name: 'XiaomanSetFields',
      component: () => isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/xiaoman/setFields/SetFieldsMain'),
      meta: {
        title: '小满集成',
        menuKey: 'project-config'
      }
    }]
  }
]
